module.exports = __webpack_public_path__ + "static/img/step02.7e90704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step02.png
// module id = Ac09
// module chunks = 1